/*
 * PERLOTUS PREMIUM V2 — ürün önerileri yükleyicisi
 *
 * <pv2-recommendations data-url="…" data-intents="complementary,related">
 * Bölüm görünür alana yaklaşınca öneri türlerini sırayla dener; ilk dolu sonucu
 * (sunucuda aynı bölümle çizilmiş HTML) yerleştirir. Hiç öneri yoksa bölüm gizlenir.
 */

if (!customElements.get('pv2-recommendations')) {
  customElements.define(
    'pv2-recommendations',
    class Pv2Recommendations extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('[data-pv2-recs-loaded]')) return;

        if (!('IntersectionObserver' in window)) {
          this.load();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      async load() {
        const intents = (this.dataset.intents || 'related').split(',').filter(Boolean);

        for (const intent of intents) {
          try {
            const response = await fetch(`${this.dataset.url}&intent=${intent}`);
            if (!response.ok) continue;
            const html = document.createElement('div');
            html.innerHTML = await response.text();
            const loaded = html.querySelector('pv2-recommendations [data-pv2-recs-loaded]');
            if (loaded) {
              this.innerHTML = '';
              this.appendChild(loaded);
              return;
            }
          } catch (error) {
            // Ağ hatasında bir sonraki öneri türü denenir
          }
        }

        const sectionWrapper = this.closest('.shopify-section');
        (sectionWrapper || this).hidden = true;
      }
    }
  );
}
